import React from "react";
import PropTypes from "prop-types";
import {
  CardWrapper,
  Title,
  LogoRow,
  Logo,
} from "./AvailableBrokersCard.styles";
import { BLOCKED_BROKERS } from "utils/constants";

const AvailableBrokersCard = ({ brokers }) => {
  const visibleBrokers = brokers.filter(
    (broker) => !BLOCKED_BROKERS.includes(broker.slug)
  );
  return (
    <CardWrapper>
      <Title>Available on</Title>
      <LogoRow>
        {visibleBrokers.map((broker, index) => (
          <Logo
            key={broker.slug}
            src={broker.square_logo_url}
            alt={broker.display_name}
            $index={index}
            title={broker.display_name}
          />
        ))}
      </LogoRow>
    </CardWrapper>
  );
};

AvailableBrokersCard.propTypes = {
  brokers: PropTypes.arrayOf(
    PropTypes.shape({
      slug: PropTypes.string.isRequired,
      logo_url: PropTypes.string,
      square_logo_url: PropTypes.string,
      display_name: PropTypes.string,
    })
  ).isRequired,
};

export default AvailableBrokersCard;
